import React, { useEffect, useRef, useState } from "react";

export function PdfCanvasViewer({ blob, url }) {
  const ref = useRef(null);
  const [fallback, setFallback] = useState(false);
  useEffect(() => {
    let cancelled = false;
    setFallback(false);
    (async () => {
      try {
        const pdfjs = await import("pdfjs-dist");
        pdfjs.GlobalWorkerOptions.workerSrc = "/pdf.worker.min.mjs";
        const buf = await blob.arrayBuffer();
        const doc = await pdfjs.getDocument({ data: buf }).promise;
        if (cancelled || !ref.current) return;
        const container = ref.current;
        container.innerHTML = "";
        const dpr = window.devicePixelRatio || 1;
        for (let i = 1; i <= doc.numPages; i++) {
          const page = await doc.getPage(i);
          const base = page.getViewport({ scale: 1 });
          const scale = Math.max(0.5, (container.clientWidth - 24) / base.width);
          const viewport = page.getViewport({ scale: scale * dpr });
          const canvas = document.createElement("canvas");
          canvas.width = viewport.width;
          canvas.height = viewport.height;
          canvas.style.width = `${viewport.width / dpr}px`;
          canvas.style.display = "block";
          canvas.style.margin = "0 auto 12px";
          canvas.style.background = "white";
          canvas.style.boxShadow = "0 1px 8px rgba(0,0,0,0.35)";
          if (cancelled || !ref.current) return;
          container.appendChild(canvas);
          await page.render({ canvasContext: canvas.getContext("2d"), viewport }).promise;
        }
      } catch (e) {
        if (!cancelled) setFallback(true);
      }
    })();
    return () => { cancelled = true; };
  }, [blob]);
  if (fallback) {
    return <iframe title="PDF preview" src={url} className="flex-1 rounded-b-2xl"
      style={{ border: 0, background: "#3f4245", minHeight: 0 }} data-testid="pdf-iframe-fallback" />;
  }
  return <div ref={ref} className="flex-1 overflow-y-auto rounded-b-2xl p-3" style={{ background: "#3f4245" }} data-testid="pdf-canvas-container" />;
}
